module.exports = __webpack_public_path__ + "static/img/A136.94dedc96.jpg";